import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-home",
  "use": "icon-s-home-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-home\"><path d=\"M16 5V3h2v3.6l4 3.2-1.294 1.617L19 10.052V20H3v-9.948l-1.706 1.365L0 9.8 11 1zm1 3.452-6-4.8-6 4.8v9.622h12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol